/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Cart count badges - Animate every 5 sec
setInterval(() => {
    document.querySelectorAll('.cart-count-badge').forEach((badge) => {
        badge.classList.add(badge.dataset.animateClass)

        setTimeout(() => {
            badge.classList.remove(badge.dataset.animateClass)
        }, 2000)
    })
}, 5000)

// Scroll to F.A.Q through a hash link
if (window.location.hash.includes('faq')) {
    setTimeout(() => {
        const section = document.querySelector('.richtext')
        if (section) {
            section.scrollIntoView()
        }
    }, 500)
}

// Cycle words for West and Willow
document.querySelectorAll('.ww-cycle-words').forEach(element => {
    console.log(element)
    let x = 0
    setInterval(() => {
        const words = ['mug', 'pet bowl', 'accessory', 'phone case', 'stickers']

        element.style.transition = 'all .2s ease-out'
        element.style.opacity = 0

        setTimeout(() => {
            element.textContent = words[x]
            element.style.opacity = 1
        }, 200)

        x += 1

        if (x === words.length - 1) {
            x = 0
        }
    }, 2000)
})

// Insert Offcanvas Nav Announcements within the megamenu in desktop
if (window.matchMedia('(min-width: 1200px)').matches) {
    const element = document.querySelector('#offcanvas-nav-announcements')
    element.classList.remove('mb-8')
    element.classList.add('mb-4')

    document.querySelector('.dropdown-megamenu .col-5')
        ?.insertAdjacentElement('afterbegin', element)
}

// Before/After Slider init
// https://image-compare-viewer.netlify.app/
document.querySelectorAll('.image-compare').forEach((el) => {
    new ImageCompare(el, {
        showLabels: true,
        labelOptions: {
            before: 'Before',
            after: 'After'
        },
        smoothing: false,
        hoverStart: true
    }).mount()
})
